<template>
  <div class="shop-menu-options main">
    <div class="background" @click="close" />

    <div ref="scrollable" class="wrapper no-scrollbar" :class="{ 'wrapper-tall': isTallWrapper }" :key="z">
      <div class="close-wrapper" @click="close">
        <button class="delete is-large" />
      </div>
      <figure v-if="pic" class="image" @click="toggleImageHeight">
        <img :class="{ 'tall-img': tallerImage, 'contain-img': item.contain_image }" :style="imgStyle" v-webp="pic"
          height="200px" width="200px" @error="defaultImg" />
        <i class="fa fa-expand" />
        <i v-if="isMembersOnly" class="fa fa-lock has-text-white" />
        <div v-if="isMembersOnly" class="lock">
          <i v-if="userIsMember" class="fa fa-lock-open has-text-white" />
          <i v-else class="fa fa-lock has-text-white" />
        </div>
        <div v-if="qty" class="qty">
          {{ qty }}
        </div>
      </figure>
      <figure v-else class="has-text-left" style="margin-bottom: 12px">
        <div class="placeholder-figure" />
        <div v-if="qty" class="qty" style="left: 0">
          {{ qty }}
        </div>
      </figure>
      <!-- <div class="close-wrapper" @click="close">
        <button class="delete is-large" />
      </div> -->
      <div style="margin-bottom: 12px" :class="{ rtl: isRTL }">
        <div class="subtitle is-flex">
          <span style="flex: 1">{{ itemName }}</span>
          <span class="has-text-link" @click="shareMenuItem">
            <i class="fa fa-share-alt fa-sm" style="padding: 4px" />
          </span>
        </div>
        <div class="description">{{ itemDescription }}</div>
        <div v-if="item.by_weight" class="prep-time">
          Price {{ item.by_weight }}, ~{{ item.estimated_weight }} grams per
          piece
          <br />
          *Price will be calculated based on actual weight*
        </div>
        <div v-if="longPrepTime(item)" class="prep-time">
          This item has a longer prep time
          <i class="fa fa-stopwatch" />
          {{ item.prep_time }} minutes
        </div>
        <div v-if="isFreeGift" class="prep-time">
          <i class="fa fa-gift has-text-danger" />
          Free Gift over {{ currency }}{{ item.free_gift }}
        </div>
        <div class="tags" style="margin-top: 6px">
          <span v-if="isFreeGift" class="tag has-text-danger"><i class="fa fa-gift" />&nbsp;Free Gift</span>
          <span v-if="isMembersOnly" class="tag has-text-link">
            <span v-if="userIsMember"><i class="fa fa-star has-text-warning" />
              {{ $t("Member Special") }}
              <i class="fa fa-lock-open" />
            </span>
            <span v-else><i class="fa fa-lock" />&nbsp;Members Only</span>
          </span>
          <span v-if="item.special" class="tag has-text-link"><i
              class="fa fa-star has-text-warning" />&nbsp;Special</span>
          <span v-if="item.flash_deal" class="tag has-text-warning"><i class="fa fa-bolt" />&nbsp;Flash Deal</span>
          <!-- <span v-if="longPrepTime(item)" class="tag has-text-black"
            ><i class="fa fa-stopwatch" />&nbsp;{{ item.prep_time }} mins</span
          > -->
          <span v-if="item.max_count" class="tag has-text-danger">{{ $t("max") }} {{ item.max_count }}</span>
          <span v-for="t in tags(item)" :key="t" class="tag is-capitalized">
            <span v-if="t.startsWith('*')">
              <i class="far fa-clock" />
              {{ t.replace("*", "") }}
            </span>
            <span v-else>{{ t }}</span></span>
        </div>
      </div>

      <div v-if="!isFreeGift && item.price > 0" class="options is-flex">
        <div class="has-text-left" style="flex: 1; padding: 6px">
          <i v-if="hasOptionsMenus">{{ $t("options") }}</i>
        </div>
        <div class="price has-text-right" style="flex: 1">
          <span v-if="hasOptionsMenus">{{ $t("base") }}</span>&nbsp;
          <span class="tag is-medium">
            <span v-if="item.discount">
              <span class="normal-price">{{ currency }}{{ item.price }}</span>
              <span class="has-text-danger has-text-weight-medium">
                {{ currency }}{{ discountedPrice(item) }}
              </span>
            </span>
            <span v-else>{{ currency }}{{ item.price }} </span>
            <span v-if="item.by_weight" class="has-text-grey has-text-weight-medium">{{ translateByWeight(item.by_weight)
            }}</span>
          </span>
          <div v-if="item.vatable" class="vat">+VAT</div>
        </div>
      </div>

      <div v-for="m in filteredOptionsMenus" :key="m.id + y" :ref="m.id" class="option-menu"
        :class="{ invalid: invalidOptionsMenu(m) }">
        <!-- :class="{ invalid: invalidOptionsMenu(m) }" -->
        <div style="display: flex">
          <div style="flex: 1; margin-top: auto">
            <span class="options-name" style="margin-right: 1px">
              {{ optionsMenuName(m.data) }}
            </span>
            <p v-if="optionsMenuInstruction(m.data)" class="has-text-grey">
              {{ optionsMenuInstruction(m.data) }}
            </p>
            <!-- <i v-if="m.data.required" class="required has-text-danger">
              {{ $t("required") }}
            </i>
            <i v-else class="required">{{ $t("optional") }}</i> -->
          </div>
          <div style="flex-shrink: 2; text-align: right; margin-top: auto">
            <p class="required">
              <span v-if="m.data.required" class="has-text-danger">
                {{ $t("required") }}
              </span>
              <span v-else>{{ $t("optional") }}</span>
            </p>
            <span class="hint">
              <span v-if="m.data.select === 'single'">{{
                $t("choose-one")
              }}</span>
              <!-- <span v-else>{{ $t("choose-multiple") }}</span> -->
              <span v-else>
                <span v-if="m.data.multiple_constraint === 'none'">{{
                  $t("choose-multiple")
                }}</span>
                <span v-if="m.data.multiple_constraint === 'up_to'">{{ $t("choose-up-to") }} {{ m.data.multiple_n
                }}</span>
                <span v-if="m.data.multiple_constraint === 'exactly'">{{ $t("choose") }} {{ m.data.multiple_n }}</span>
              </span>
            </span>
          </div>
        </div>

        <p v-if="invalidMenus.includes(m.id)" class="invalid-callout">
          <!-- Invalid: -->
          <span v-if="m.data.select === 'single'">{{ $t("choose-one") }}</span>
          <!-- <span v-else>{{ $t("choose-multiple") }}</span> -->
          <span v-else>
            <span v-if="m.data.multiple_constraint === 'none'">{{
              $t("choose-multiple")
            }}</span>
            <span v-if="m.data.multiple_constraint === 'up_to'">{{ $t("choose-up-to") }} {{ m.data.multiple_n }}</span>
            <span v-if="m.data.multiple_constraint === 'exactly'">{{ $t("choose") }} {{ m.data.multiple_n }}</span>
          </span>
        </p>
        <!-- <div v-for="o in m.data.items" :key="o.id" class="option-item"> -->
        <div v-for="o in expandableItems(m)" :key="o.id" class="option-item"
          :class="{ 'selected-option': optionSelected(o) }">
          <p class="is-pointer" @click="select(m, o)">
            <span class="option-item-name">{{ optionsItemName(o) }}</span>

            <!-- v-if="optionSelected(o) && m.data.select === 'multiple'" -->
            <span v-if="optionSelected(o) && allowMultiple(m)" :key="o.quantity + 'o.id'">
              <fade-transition>
                <span v-if="selectingID === o.id" class="selected-buttons">
                  <span class="button is-info is-rounded" style="padding: 6px; margin-right: 6px"
                    @click.stop="removeQuantity(o)"><i class="fa fa-minus-circle fa-lg" /></span>
                  <span class="button is-info is-rounded" style="padding: 6px" @click="addQuantity(o)"><i
                      class="fa fa-plus-circle fa-lg" /></span>
                </span>
              </fade-transition>

              <span :key="o.quantity" class="button quantity" style="padding: 12px; font-weight: 500">{{ o.quantity
              }}</span>
            </span>

            <span v-if="o.out_of_stock" class="button is-pulled-right oos" style="width: 70px; top: -6px">
              <i style="font-size: 0.8em">{{ $t("commerce.sold-out") }}</i>
            </span>

            <span v-else class="button is-pulled-right" :class="{ 'is-info border-blue': optionSelected(o) }"
              style="width: 70px; top: -6px">
              <!-- @click="select(m, o)" -->
              <!-- <span v-if="parseInt(o.price)">
              <span v-if="parseInt(o.price) > 0">+</span> -->
              <span v-if="optionPrice(o)">
                <span v-if="optionPrice(o) > 0">+</span>
                <span v-else>−</span>
                <!-- {{ currency }}{{ Math.abs(o.price) }} -->
                {{ currency }}{{ Math.abs(optionPrice(o)) }}
              </span>
              <span v-else>
                <span v-if="m.data.zeros_as">{{
                  translateZerosAs(m.data.zeros_as)
                }}</span>
                <span v-else-if="m.data.show_zero">+ {{ currency }}0</span>
                <span v-else>{{ $t("free") }}</span>
              </span>
              <!-- <i v-if="!isNaN(o.discounted_price)" class="fa fa-tag" /> -->
            </span>
          </p>
          <!-- <p
            v-if="optionSelected(o) && m.data.select === 'multiple'"
            class="selected-buttons"
            :key="o.quantity + 'o.id'"
          >
            <span
              class="button is-info is-rounded"
              style="padding: 6px"
              @click="removeQuantity(o)"
              ><i class="fa fa-minus-circle fa-lg"
            /></span>
            <span
              :key="o.quantity"
              class="button"
              style="margin: 0 4px; padding: 12px; font-weight: 500"
              >{{ o.quantity }}</span
            >
            <span
              class="button is-info is-rounded"
              style="padding: 6px"
              @click="addQuantity(o)"
              ><i class="fa fa-plus-circle fa-lg"
            /></span>
          </p> -->
        </div>
        <div v-if="isExpandable(m)" class="option-item" style="padding-top: 0" @click="toggleExpandable(m)">
          <span class="option-item-name link has-text-info">
            <i v-if="m.expanded"><i class="fa fa-angle-up" />&nbsp;Show less</i>
            <i v-else> <i class="fa fa-angle-down" />&nbsp;Show more </i>
          </span>
          <span class="expand-collapse-options">
            <i v-if="!m.expanded" class="fa fa-ellipsis-h" />
            <i v-else class="far fa-window-minimize" />
          </span>
        </div>
      </div>

      <div style="margin-bottom: 68px">
        <div v-if="isMembersOnly && !userIsMember">
          <p class="notification" style="margin-bottom: 10px; padding: 10px">
            <i class="has-text-link" style="font-weight: 500; opacity: 0.6">
              Members Only Item
            </i>
            <br />
            <i>
              Enter your email address to become a member. It's simple and free!
            </i>
          </p>
          <input ref="email" class="input is-info" v-model="email" placeholder="Enter e-mail address" />
        </div>
        <div v-else-if="!item.out_of_stock">
          <textarea class="textarea no-scrollbar" :placeholder="$t('special-instructions')" rows="1" v-model="comment"
            @focus="scrollToBottom"></textarea>
        </div>
      </div>

      <div class="submit-wrapper">
        <div v-if="available" :key="y">
          <div v-if="qty" class="field is-grouped">
            <div class="button is-medium is-warning" style="margin-right: 8px" @click="removeItem">
              <i class="fa fa-minus-circle has-text-white fa-lg" />
            </div>
            <div class="control button is-medium is-info is-expanded" @click="submit">
              <p>
                <span>
                  <i class="fa fa-plus-circle fa-lg" />
                  {{ $t("menu.add-to-basket") }}
                </span>
                <span class="is-pulled-right" style="margin-top: 4px">
                  {{ currency }}{{ totalPrice }}
                </span>
              </p>
            </div>
          </div>
          <div v-else class="button is-fullwidth is-medium is-info" @click="submit">
            <p>
              <span>
                <i class="fa fa-plus-circle fa-lg" />
                {{ $t("menu.add-to-basket") }}
              </span>
              <span class="is-pulled-right" style="margin-top: 4px">
                {{ currency }}{{ totalPrice }}
              </span>
            </p>
          </div>
        </div>
        <div v-else-if="isMembersOnly && !userIsMember" class="button is-fullwidth is-medium is-link"
          @click="submitMember">
          <p>
            <span> {{ $t("menu.become-a-member") }} </span>
            <i class="is-pulled-right is-uppercase"> {{ this.$t("free") }} </i>
          </p>
        </div>
        <div v-else-if="!isOpen" class="button is-fullwidth is-medium is-danger" @click="showShopClosed">
          <p>
            <span>
              {{ $t("menu.order-when-shop-is-open") }}
            </span>
          </p>
        </div>
        <div v-else class="button is-fullwidth is-medium is-dark" @click="sendInterest">
          <p>
            <span>
              {{ $t("commerce.out-of-stock") }}
            </span>
            <i class="is-pulled-right"> Interested? </i>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "../eventBus";
const shortid = require("shortid");

export default {
  name: "ShopMenuOptions",
  components: {},
  props: {
    optionsMenus: Array,
    item: Object,
    lang: String,
    currency: String,
    qty: Number,
    w: Object, // workflow
    isOpen: Boolean,
  },
  data() {
    return {
      optionsMenusCopy: [],
      invalidMenus: [],
      triggerTimeout: null,
      selectingID: null, // for + n -
      invalid: [], // invalid options menus, didn't meet requirements
      selected: [],
      comment: null,
      expandLength: 4,
      tallerImage: false,
      isTallWrapper: false,
      email: null, // for members only
      // isMember: false, // true if member
      loginCallback: "SHOP_MENU_OPTIONS_LOGIN_MEMBER_CALLBACK",
      z: 0,
      y: 0, // quantity change
    };
  },
  computed: {
    isFreeGift() {
      return this.item.free_gift;
      // return this.item.name === "Free Gift";
    },
    propagateDiscounts() {
      if (!this.w.data.menu_options) return false;
      return this.w.data.menu_options.propagate_discounts;
    },
    isRTL() {
      return this.lang === "he";
    },
    pic() {
      if (!this.item.pic) return null; //return this.$store.state.menuItemPlaceholderPic;
      return this.item.pic;
    },
    imgStyle() {
      if (!this.isMembersOnly) return null;
      if (this.userIsMember) return null;
      return `filter: blur(2px)`;
    },
    available() {
      if (!this.isOpen) return false;
      if (this.item.out_of_stock) return false;
      if (this.isMembersOnly && !this.userIsMember) return false;
      return true;
      // return !(this.item.out_of_stock || this.isMembersOnly);
    },
    isMembersOnly() {
      if (!this.item.tags) return false;
      return this.item.tags.includes("member");
    },
    userIsMember() {
      console.log("force", this.z);
      return this.isMember(this.w.business_id);
      // return false;
    },
    hasOptionsMenus() {
      return this.item.options && this.item.options.length;
    },
    filteredOptionsMenus() {
      // var arr = this.optionsMenus.filter((m) => {
      //   return this.item.options.includes(m.id);
      // });
      if (!this.hasOptionsMenus) return [];
      if (!this.optionsMenus) return []; // prop could be null rather than []
      // this.clearConditionalOptions();
      var arr = [];
      this.item.options.forEach((o) => {
        var m = this.optionsMenusCopy.find((m) => o === m.id);
        if (!m) return; // skip if doesn't exist
        if (!m.data.items.length) return; // skip if there are no items in option menu
        if (m.data.condition) {
          var exists = this.trueCondition(m.data.condition);
          // var exists = this.selected.find((s) => {
          //   var str = JSON.stringify(s.option).toLowerCase();
          //   return str.includes(m.data.condition);
          // });
          if (!exists) return; // skip if condition doesn't check out
        }
        if (m) arr.push(m);
      });
      // sort with required options menus at top
      return arr.sort((a, b) => {
        var x = a.data.required;
        var y = b.data.required;
        return x === y ? 0 : x ? -1 : 1;
      });
    },
    requiredOptions() {
      return this.filteredOptionsMenus.filter((m) => m.data.required);
    },
    multipleOptions() {
      var menus = this.filteredOptionsMenus;
      return menus.filter((m) => m.data.select === "multiple");
    },
    itemName() {
      if (this.item[this.lang]) {
        return this.item[this.lang].name;
      }
      return this.item.name;
    },
    itemDescription() {
      if (this.item[this.lang]) {
        return this.item[this.lang].description;
      }
      return this.item.description;
    },
    totalPrice() {
      console.log("y", this.y);
      var add = 0;
      // this.selected.forEach((s) => (add += parseInt(s.option.price)));
      this.selected.forEach((s) => (add += this.optionPrice(s.option)));
      //   return parseInt(this.item.price) + add;
      return this.discountedPrice(this.item) + add;
    },
    requiredInvalid() {
      var ids = this.selected.map((o) => o.menu.id);
      return this.requiredOptions.filter((m) => {
        return !ids.includes(m.id);
      }).length;
    },
  },
  mounted() {
    this.optionsMenusCopy = this.deepCopy(this.optionsMenus);
    setTimeout(() => (this.isTallWrapper = true), 50);
    if (!this.hasOptionsMenus) this.comment = this.item.comment;

    EventBus.$on(this.loginCallback, () => this.submitMember());

    if (this.propagateDiscounts) this.updateOptionMenuPrices();

    // setTimeout(() => (this.tallerImage = true), 500);
  },
  beforeDestroy() {
    EventBus.$off(this.loginCallback);
  },
  methods: {
    close() {
      this.$emit("close");
    },
    longPrepTime(item) {
      return item.prep_time > 20;
    },
    showShopClosed() {
      var msg = this.$t("menu.shop-is-not-open-now"); //This shop is not open right now";
      this.errorToast(msg, "top");
    },
    // optionPrice(o) {
    //   return parseInt(o.discounted_price || o.price);
    // },
    updateOptionMenuPrices() {
      if (this.item.discount_type && this.item.discount_type !== "percent")
        return; // only do for percent discounts, if discount_type not set it is percent
      var discount = this.item.discount; // percent discount like 10%
      var discountFactor = 1 - parseInt(discount) / 100; // 0.9
      this.filteredOptionsMenus.forEach((m) => {
        m.data.items.forEach((i) => {
          i.discounted_price = parseInt(i.price) * discountFactor;
        });
      });
    },
    triggerSelecting(o) {
      if (this.triggerTimeout) clearTimeout(this.triggerTimeout);
      this.selectingID = o.id;
      this.triggerTimeout = setTimeout(() => (this.selectingID = null), 4000);
    },
    shareMenuItem() {
      var url = window.location.href + `?search=${this.item.id}`; //&tab=promos`;
      // or something like: tukapp.co/i/itemID?
      this.$copyText(url);
      this.infoToast(`Copied menu item URL<br>${url}`, "top");
    },
    invalidOptionsMenu(m) {
      var constraint = m.data.multiple_constraint;
      var n = m.data.multiple_n;
      if (m.data.select === "multiple" && constraint !== "none") {
        var total = 0;
        this.selected
          .filter((o) => o.menu.id === m.id)
          .forEach((o) => {
            total += o.option.quantity;
          });
        if (total > n) return true;
      }
      return false;
    },
    invalidOptionsMenuStrict(m) {
      if (m.data.select !== "multiple") return false;
      var constraint = m.data.multiple_constraint;
      var n = parseInt(m.data.multiple_n);
      var total = 0;
      this.selected
        .filter((o) => o.menu.id === m.id)
        .forEach((o) => {
          total += o.option.quantity;
        });
      if (constraint === "up_to" && total > n) return true;
      if (constraint === "exactly" && total !== n) return true;
      return false;
    },
    checkRequirements() {
      this.invalidMenus = []; // reset
      // simplest: are required menus selected?
      var ids = this.selected.map((o) => o.menu.id);
      this.requiredOptions.forEach((m) => {
        if (!ids.includes(m.id)) this.invalidMenus.push(m.id);
      });
      // complicated: are correct number selected if multiple?
      this.multipleOptions.forEach((m) => {
        if (this.invalidOptionsMenuStrict(m)) this.invalidMenus.push(m.id);
      });
    },
    tags(item) {
      if (!item.tags) return [];
      var remove = ["member"]; // skip these, handled separately
      return item.tags.filter((t) => !remove.includes(t));
    },
    sendInterest() {
      // this.sendEmail(o);
      console.log("sendInterest", this.item);
      // var msg = `User interested in OUT OF STOCK item: ${this.item.name} ${this.item.id}`;
      // this.sendSuperuserNotification(msg);
      var title = "customer-interested-in-out-of-stock-item";
      var msg = this.item.name;
      if (this.item.category) msg += ` (${this.item.category})`;
      // msg += ` @ ${businessName}`
      this.sendCommerceAgentNotification(this.w.id, title, msg);
      msg = `🙏🏼 Thank you for you interest<br>We'll try to get it back in stock ASAP`;
      this.infoToast(msg);
    },
    toggleImageHeight() {
      this.tallerImage = !this.tallerImage;
      if (this.isMembersOnly && !this.userIsMember) {
        setTimeout(() => this.focusEmail(), 1000);
      }
    },
    focusEmail() {
      this.$refs.email.focus();
      this.scrollToBottom();
      this.triggerEmailToast();
    },
    triggerEmailToast() {
      setTimeout(() => this.infoToast("Enter email address", "top"), 600);
    },
    scrollToBottom(ms) {
      var delay = ms || 999;
      setTimeout(() => this.$refs.scrollable.scrollTo(0, 999), delay);
    },
    defaultImg(e) {
      e.target.src = this.$store.state.menuItemPlaceholderPic;
    },
    isExpandable(m) {
      return m.data.items.length > this.expandLength;
    },
    toggleExpandable(m) {
      m.expanded = !m.expanded;
      this.z += 1;

      this.$nextTick(() => {
        this.$refs[m.id][0].scrollIntoView(); // { behavior: "smooth" }
        // this.$refs.scrollable.scrollBy(0, -10); // Adjust scrolling with a negative value here
        if (!m.expanded) return;
        this.$refs.scrollable.scrollBy(0, -100);
        this.$refs.scrollable.scrollBy({ top: 90, behavior: "smooth" });
      });
    },
    expandableItems(m) {
      if (!this.isExpandable(m)) return m.data.items;
      if (m.expanded) return m.data.items;
      return m.data.items.slice(0, this.expandLength);
    },
    optionsMenuName(o) {
      if (o[this.lang]) return o[this.lang];
      return o.name;
    },
    optionsMenuInstruction(o) {
      if (!o.instruction) return null;
      return o.instruction[this.lang];
    },
    optionsItemName(o) {
      if (o[this.lang]) return o[this.lang].name;
      return o.name;
    },
    optionSelected(o) {
      return this.selected.find((s) => s.option.id === o.id);
    },
    trueCondition(condition) {
      return this.selected.find((s) => {
        var str = JSON.stringify(s.option).toLowerCase();
        return str.includes(condition);
      });
    },
    clearConditionalOptions() {
      this.selected.forEach((s) => {
        var condition = s.menu.condition;
        if (condition) {
          if (!this.trueCondition(condition)) this.remove(s.option);
        }
      });
    },
    remove(o) {
      var idx = this.selected.findIndex((s) => s.option.id === o.id);
      this.selected[idx].option.quantity = null; // reset quantity
      this.selected.splice(idx, 1);
    },
    removeSingleOption(m) {
      var idx = this.selected.findIndex((s) => s.menu.id === m.id);
      if (idx === -1) return;
      console.log("removeSingleOption", idx, m, this.selected[idx]);
      this.selected[idx].option.quantity = null; // reset quantity
      this.selected.splice(idx, 1);
      // this.clearConditionalOptions();
    },
    allowMultiple(m) {
      return m.data.select === "multiple" && m.data.allow_multiple;
    },
    select(m, o) {
      if (o.out_of_stock) {
        var msg = "Option Out of Stock";
        this.infoToast(msg, "top");
        return;
      }
      this.triggerSelecting(o);
      // if (this.optionSelected(o) && m.data.select === "multiple") return;
      if (this.optionSelected(o) && this.allowMultiple(m)) return;
      this.$nextTick(() => this.clearConditionalOptions());
      if (this.optionSelected(o)) {
        this.remove(o);
        // this.clearConditionalOptions();
        return;
      }
      if (m.data.select === "single") this.removeSingleOption(m); // check and remove previous single
      var menu = this.deepCopy(m.data); //JSON.parse(JSON.stringify(m.data));
      menu.id = m.id; // add ID
      delete menu.items;
      delete menu.required;
      delete menu.select;
      // delete more things from the option menu? now have a lot
      if (o.quantity) o.quantity += 1;
      else o.quantity = 1;
      this.selected.push({
        menu: menu, // already deepCopy above
        option: o, //this.deepCopy(o),
      });
    },
    removeItem() {
      this.$emit("remove", this.item);
    },
    removeQuantity(o) {
      o.quantity -= 1;
      if (o.quantity === 0) {
        this.remove(o);
      }
      this.y += 1;
    },
    addQuantity(o) {
      o.quantity += 1;
      this.y += 1;
    },
    submit() {
      // handle case where max_count is null or 0, which means no max_count, skip
      if (this.item.max_count && this.qty >= this.item.max_count) {
        var errMsg = this.$t("menu.you-have-max-allowed") + this.item.max_count; // You have the max allowed: 3
        this.errorToast(errMsg);
        return;
      }
      if (this.item.free_gift && this.qty >= 1) {
        var freeGiftMsg = "You can only order 1 Free Gift";
        this.errorToast(freeGiftMsg);
        return;
      }
      this.checkRequirements(); // TODO
      if (this.requiredInvalid || this.invalidMenus.length) {
        var msg = this.$t("menu.select-required-option");
        this.warningToast(msg, "top");
        this.scrollToBottom(500);
        return;
      }
      var item = this.deepCopy(this.item);
      if (this.hasOptionsMenus) {
        item.id2 = shortid.generate(); // add an extra id field for use in removal function
      }
      item.options = this.selected;
      item.comment = this.comment;
      this.$emit("submit", item);
      this.close();
    },
    validEmail() {
      if (!this.email) return false;
      if (this.email.length < 5) return false;
      if (!this.email.includes("@")) return false;
      return true;
    },
    submitMember() {
      var msg = "Please login first";
      if (!this.smsLoginOkay(msg, this.loginCallback)) return; //msg, this.loginCheckoutCallback
      if (!this.validEmail()) {
        this.focusEmail();
        return;
      }
      // otherwise become a member
      this.createMemberRole();
    },
    createMemberRole() {
      var data = {
        name: this.$store.getters.realName,
        email: this.email,
        // membership_number: this.membershipNumber,
        // notes: this.notes,
        // membership_length: this.expiry,
        // expiry_date: new Date(this.valueOf() + 24 * 60 * 60 * this.expiry),
      };
      var loader = this.loadingDots("blue");
      this.$store
        .dispatch("createRole", {
          phone_number: this.$store.getters.phoneNumber,
          business_id: this.w.business_id,
          workflow_id: this.w.id,
          workflow_name: this.w.name,
          role_type: "customer",
          role_name: "Member",
          data: data,
        })
        .then((res) => {
          this.console("createMemberRole success", res);
          this.updateRoles(false);
          var msg = "You're a member!";
          setTimeout(() => this.successToast(msg, "top"), 800);
          this.z += 1;
          // should bring business name into component
          this.log("member_joined_shop", this.itemName);
          var txt = `❤️ Member joined @ ${this.itemName} (${this.email})`;
          this.sendSuperuserNotification(txt);
        })
        .catch((err) => this.apiError(err))
        .finally(() => loader.hide());
    },
  },
};
</script>

<style scoped>
.main {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  /* background-color: rgba(255, 255, 255, 0); */
  background-color: rgba(128, 128, 128, 0.5);
  z-index: 21;
  backdrop-filter: blur(1px);
}

.background {
  position: absolute;
  top: 0;
  width: 100vw;
  height: 100vh;
}

.wrapper {
  position: absolute;
  bottom: 0;
  right: 0;
  max-width: 500px;
  height: auto;
  max-height: calc(100vh - 60px);
  overflow: scroll;
  width: 100vw;
  overflow-x: hidden;
  padding: 12px;
  background-color: white;
  text-align: left;
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
  transition: max-height 0.2s linear;
  box-shadow: 0 0 3px #444;
}

.wrapper-tall {
  max-height: calc(100vh - 10px);
}

.subtitle {
  font-size: 1.4em;
  font-weight: 500;
  /* margin-bottom: 12px; */
  margin-bottom: 0;
  /* max-width: calc(100vw - 60px); */
}

.options {
  /* text-align: right; */
  /* font-weight: 500; */
  margin-bottom: 16px;
}

.hint {
  /* float: right; */
  font-size: 0.9em;
  font-weight: 500;
  opacity: 0.6;
}

.close-wrapper {
  /* position: absolute; */
  position: fixed;
  /* top: 0; */
  margin-top: -12px;
  right: 0;
  padding: 8px 12px;
  z-index: 2;
}

.options-name {
  font-weight: 500;
}

.option-menu {
  margin-bottom: 16px;
}

.invalid {
  /* border: 1px solid salmon; */
  /* box-shadow: 0 0 2px rgba(255, 0, 0, 0.3); */
  background-color: rgba(255, 0, 0, 0.1);
  border-radius: 4px;
  /* padding: 1px 3px; */
}

.option-item {
  position: relative;
  padding: 8px;
  padding-right: 0;
}

.option-item-name {
  display: inline-block;
  margin-left: 4px;
  max-width: calc(100vw - 110px);
  /* margin-top: 4px; */
}

.option-item .fa-tag {
  position: absolute;
  font-size: 0.5em;
  right: 0;
  padding: 2px;
  color: rgb(255, 199, 213);
}

.required {
  /* margin-left: 6px;
  font-size: 0.8em;
  font-weight: 500;
  opacity: 0.7;
  background-color: rgba(232, 232, 232);
  border-radius: 3px;
  padding: 3px; */
  font-size: 0.8em;
  font-weight: 500;
  opacity: 0.7;
  /* background-color: rgba(232, 232, 232); */
  background-color: whitesmoke;
  border-radius: 3px;
  padding: 0;
  text-align: center;
  box-shadow: 0 0 1px #bbb;
}

.notification {
  padding: 20px;
}

.textarea {
  border-radius: 2px;
}

.submit-wrapper {
  position: fixed;
  bottom: 0;
  /* left: 0; */
  width: 100vw;
  right: 0;
  max-width: 500px;
  padding: 12px;
  background-color: rgba(232, 232, 232, 0.5);
  backdrop-filter: blur(1px);
}

.normal-price {
  text-decoration: line-through;
  margin-right: 10px;
  font-size: 0.95em;
  color: grey;
}

.option-item-name.link {
  font-weight: 450;
  font-size: 0.9em;
  /* color: #999; */
}

.expand-collapse-options {
  margin-top: 4px;
  position: absolute;
  right: 26px;
}

.fa-window-minimize {
  color: grey;
  line-height: 0;
  vertical-align: top;
}

figure {
  /* padding: -12px; */
  /* margin-top: 10px; */
  width: 100vw;
  max-width: 500px;
  margin: auto;
  margin-bottom: 8px;
}

img {
  margin-top: -12px;
  margin-left: -12px;
  /* margin-left: -6px; */
  object-fit: cover;
  object-position: center;
  /* height: 110px; */
  max-height: 200px;
  /* width: calc(100vw + 24px); */
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.14);
  /* margin: auto; */
  transition: max-height 0.2s ease;
  transition: border-radius 0.2s ease;
  border-bottom-left-radius: 50%;
  /* border-bottom-right-radius: 10%; */
  animation: move 4s linear;
  transform: translateZ(0);
  will-change: transform;
}

@keyframes move {
  from {
    object-position: bottom;
  }

  to {
    object-position: center;
  }
}

.contain-img {
  object-fit: contain !important;
}

.tall-img {
  max-height: 500px;
  border-radius: 0;
}

.qty {
  position: absolute;
  left: -12px;
  margin-top: -46px;
  text-shadow: 0 0 1px rgba(0, 0, 0, 0.5);
  /* background-color: hsl(171, 100%, 41%); */
  background-color: #209cee;
  padding: 12px 10px;
  width: 46px;
  height: 46px;
  border-top-right-radius: 50px;
  font-size: 1.3em;
  color: white;
  font-weight: 450;
  text-shadow: 1px 1px 1px #333;
  box-shadow: 1px -1px 2px rgba(0, 0, 0, 0.14);
}

.fa-expand {
  position: absolute;
  right: 30px;
  margin-top: -30px;
  color: white;
  text-shadow: 0 0 1px rgba(0, 0, 0, 0.5);
}

figure .lock {
  position: absolute;
  top: 12px;
  left: 4px;
  /* opacity: 0.5; */
  /* filter: drop-shadow(1px 1px 1px rgba(0, 0, 0, 1)); */
  text-shadow: 0 0 1px rgba(0, 0, 0, 1);
}

.description {
  white-space: pre-wrap;
  font-weight: 450;
  opacity: 0.7;
}

.submit-wrapper .fa-plus-circle {
  margin-right: 6px;
  margin-top: 8px;
}

.button p {
  width: 100%;
  text-align: left;
  display: table;
}

.button p>span {
  /* position: absolute;
  top: 50%;
  margin-top: -22px; */
  /* display: inline-block; */
  /* padding: 9px; */
  /* line-height: 45px; */
  display: table-cell;
  vertical-align: middle;
}

.tags .tag {
  padding: 4px;
  color: rgb(255, 255, 255);
  background-color: #ccc;
  font-weight: 500;
  /* color: grey; */
  height: 1.5em;
}

.has-text-warning {
  text-shadow: 1px 0 1px black, 0 0 2px grey;
}

.option-item .button {
  /* box-shadow: 1px 1px 2px lightblue; */
  border: 1px solid #209cee80;
}

.oos {
  opacity: 0.5;
  border: 1px solid #ddd !important;
  background-color: #ddd;
}

.border-blue {
  border: 1px solid blue !important;
}

.selected-option {
  border: 1px solid #ddd;
  border-radius: 4px;
  margin: 4px -3px;
  padding-right: 2px;
}

/* .selected-buttons {
  text-align: center;
  margin-top: 12px;
} */
.selected-buttons {
  /* display: inline-block; */
  position: absolute;
  right: 2px;
  margin-right: 110px;
  padding: 0 8px;
  border-radius: 4px;
  margin-top: -6px;
  background-color: white;
  text-align: center;
  /* z-index: 1; */
}

.button.quantity {
  position: absolute;
  margin-top: -6px;
  right: 75px;
  border: 1px solid grey;
}

.placeholder-figure {
  height: 30px;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  border-bottom-right-radius: 16px;
  /* width: calc(100vw - 66px); */
  /* max-width:calc(500px - 66px); */
  width: calc(100% - 20px);
  margin-top: -3px;
  margin-left: -3px;
  background-color: #e5e5f7;
  opacity: 0.4;
  background-image: linear-gradient(30deg,
      #bdbdbe 12%,
      transparent 12.5%,
      transparent 87%,
      #bdbdbe 87.5%,
      #bdbdbe),
    linear-gradient(150deg,
      #bdbdbe 12%,
      transparent 12.5%,
      transparent 87%,
      #bdbdbe 87.5%,
      #bdbdbe),
    linear-gradient(30deg,
      #bdbdbe 12%,
      transparent 12.5%,
      transparent 87%,
      #bdbdbe 87.5%,
      #bdbdbe),
    linear-gradient(150deg,
      #bdbdbe 12%,
      transparent 12.5%,
      transparent 87%,
      #bdbdbe 87.5%,
      #bdbdbe),
    linear-gradient(60deg,
      #bdbdbe77 25%,
      transparent 25.5%,
      transparent 75%,
      #bdbdbe77 75%,
      #bdbdbe77),
    linear-gradient(60deg,
      #bdbdbe77 25%,
      transparent 25.5%,
      transparent 75%,
      #bdbdbe77 75%,
      #bdbdbe77);
  background-size: 16px 28px;
  background-position: 0 0, 0 0, 8px 14px, 8px 14px, 0 0, 8px 14px;
}

.invalid-callout {
  width: 100%;
  background-color: rgb(255, 215, 222);
  border-radius: 4px;
  padding: 2px 4px;
  margin-top: 3px;
  color: grey;
  font-weight: 500;
  text-align: center;
}

.vat {
  font-size: 0.55em;
  padding: 2px;
  position: absolute;
  right: 12px;
}

.prep-time {
  font-size: 0.75em;
  color: black;
  font-weight: 500;
  margin: 8px;
}
</style>